import * as React from "react";
import RichTextInput from 'ra-input-rich-text';
import {
    List,
    Datagrid,
    TextField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
} from 'react-admin';
import { DefaultEditCreateActions, DefaultListActions, DefaultPagination, DefaultListPerPage } from '../lib/defaultConfig';
import { DefaultFilterSidebar, IdFilter } from "../components/ListFilters";

export const FaqList = props => (
    <List {...props} actions={<DefaultListActions />} pagination={<DefaultPagination />}
        perPage={DefaultListPerPage}
        aside={<DefaultFilterSidebar>
            <IdFilter />
        </DefaultFilterSidebar>}
    >
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="title" />
        </Datagrid>
    </List>
);
export const FaqEdit = props => (
    <Edit {...props} actions={<DefaultEditCreateActions/>} mutationMode={'pessimistic'}>
        <SimpleForm>
            <TextInput source="title" fullWidth />
            <RichTextInput source="content" />
        </SimpleForm>
    </Edit>
);
export const FaqCreate = props => (
    <Create {...props} actions={<DefaultEditCreateActions/>}>
        <SimpleForm>
            <TextInput source="title" fullWidth />
            <RichTextInput source="content" />
        </SimpleForm>
    </Create>
);